import React, { useState } from 'react';
import { BsClipboard, BsCheck2 } from 'react-icons/bs';

function CodeBlock({ children, className }) {
  const [copied, setCopied] = useState(false);
  
  // Extract language from className (e.g., "language-yaml")
  const language = className ? className.replace('language-', '') : '';
  
  const copyCode = () => {
    const code = children?.props?.children || children;
    const textContent = typeof code === 'string' ? code : code?.toString() || '';
    
    navigator.clipboard.writeText(textContent.trim()).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="code-block-wrapper">
      <div className="code-block-header">
        {language && <span className="code-language">{language.toUpperCase()}</span>}
        <button
          onClick={copyCode}
          className="code-copy-button"
          aria-label="Copy code"
        >
          {copied ? (
            <>
              <BsCheck2 size={16} />
              <span>Copied!</span>
            </>
          ) : (
            <>
              <BsClipboard size={16} />
              <span>Copy</span>
            </>
          )}
        </button>
      </div>
      <pre className={className}>
        {children}
      </pre>
    </div>
  );
}

export default CodeBlock;